var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('item-base',{attrs:{"route-name":_vm.routeName,"icon":"wrench"}},[_vm._v(" APIテスト ")])}
var staticRenderFns = []

export { render, staticRenderFns }